import { lazy } from 'react';

const OrganisationOtherOptionContainer = lazy(
  () => import('../containers/OrganisationOtherOptionContainer'),
);

const OrganisationOtherOptionRoute = () => <OrganisationOtherOptionContainer />;

export default OrganisationOtherOptionRoute;
